/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__error = /** @type {(inputs: {}) => string} */ () => {
	return `Die Informationen konnten nicht angezeigt werden.`
};

const en_route__error = /** @type {(inputs: {}) => string} */ () => {
	return `The information couldn't be displayed.`
};

const es_route__error = /** @type {(inputs: {}) => string} */ () => {
	return `No se ha podido mostrar la información.`
};

const fr_route__error = /** @type {(inputs: {}) => string} */ () => {
	return `Les informations n'ont pas pu être affichées.`
};

const it_route__error = /** @type {(inputs: {}) => string} */ () => {
	return `Non è stato possibile visualizzare le informazioni.`
};

const nl_route__error = /** @type {(inputs: {}) => string} */ () => {
	return `De informatie kon niet worden weergegeven.`
};

const pt_route__error = /** @type {(inputs: {}) => string} */ () => {
	return `Não foi possível mostrar as informações.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__error", locale)
	if (locale === "de") return de_route__error(inputs)
	if (locale === "en") return en_route__error(inputs)
	if (locale === "es") return es_route__error(inputs)
	if (locale === "fr") return fr_route__error(inputs)
	if (locale === "it") return it_route__error(inputs)
	if (locale === "nl") return nl_route__error(inputs)
	return pt_route__error(inputs)
};